import { breakpoints, useMatchMedia } from '@frontend/responsiveness';

export const SCHEDULE_SETTINGS_SMALL_BREAKPOINT = breakpoints.small.max;
export const SCHEDULE_SETTINGS_MEDIA_CONDITION = `@media (max-width: ${SCHEDULE_SETTINGS_SMALL_BREAKPOINT}px)`;

export const useScheduleSettingsSmallMode = () => {
  const isSmallMode = useMatchMedia({ maxWidth: SCHEDULE_SETTINGS_SMALL_BREAKPOINT });

  return {
    isSmallMode,
  };
};
